import { useAppDispatch } from "@/stores/hook";
import { setLeadCurrentTab } from "../../features/leads/stores/leadFunctionalSlice";
import useCurrentIndustry from "@/hooks/globalapis/useCurrentIndustry";

export function useSmartRoute() {
  const { industry } = useCurrentIndustry();
  // const { unique_identifier } = useAppSelector(
  //   (state) => state.childFunctional
  // );
  const dispatch = useAppDispatch();

  return () => {
    if (industry.id == 1) {
      dispatch(setLeadCurrentTab("Course"));
    } else if (industry.id == 4) {
      dispatch(setLeadCurrentTab("Service"));
    } else if (industry.id == 5) {
      dispatch(setLeadCurrentTab("Program"));
    }
  };
}
